// extracted by mini-css-extract-plugin
export default {"container":"headline_container__KjWcn","headline1":"headline_headline1__UlggT","headline3":"headline_headline3__8aUd5","headline2":"headline_headline2__TGqGM"};